import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date.service';

@Pipe({
  name: 'dateOnly',
  standalone: true,
})
export class DateOnlyPipe implements PipeTransform {
  private dateService = inject(DateService);

  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }
    return this.dateService.formatToDateString(value);
  }
  
}
